<template>
  <div class="app-container">
    <el-row>
      <el-col :span="24">
        <!-- 面包屑导航区域-->
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/home' }">Homepage</el-breadcrumb-item>
          <el-breadcrumb-item>Quality</el-breadcrumb-item>
          <el-breadcrumb-item>QA Test Request</el-breadcrumb-item>
<!--          <el-breadcrumb-item>Project:{{project.sequenceNo}} Business Partner:{{project.bp}} Brand:{{project.brand}} Description:{{project.description}}</el-breadcrumb-item>-->
        </el-breadcrumb>
      </el-col>
    </el-row>

    <el-card>
      <el-form :inline="true" :model="queryParams" class="demo-form-inline">
        <el-row>
          <el-col :span="12">
            <el-form-item label="ID:" label-width="200px">
              <el-input v-model="queryParams.id" placeholder="ID" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Project Number:" label-width="200px">
              <el-input v-model="queryParams.projectId" placeholder="Project Number" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="Brand:" label-width="200px">
              <el-input v-model="queryParams.brand" placeholder="Brand" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="QA Status:" label-width="200px">
              <el-select v-model="queryParams.qaPlanStatus" placeholder="please choose">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Reception Date:" label-width="200px">
              <el-date-picker
                style="flex: 1"
                v-model="dateRange"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="-"
                start-placeholder="Starts Date"
                end-placeholder="End Date"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="DEV Status:" label-width="200px">
              <el-select v-model="queryParams.qaStatus" placeholder="please choose">
                <el-option
                  v-for="item in options2"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
<!--            <el-form-item style="margin-left: 4rem">-->
<!--              <p>DEV Status:Uncompleted/Completed:</p>-->
<!--              <el-switch-->
<!--                @change="qaStatusChange"-->
<!--                style="display: block"-->
<!--                v-model="queryParams.qaStatus"-->
<!--                active-color="#13ce66"-->
<!--                inactive-color="#ff4949"-->
<!--                active-value="0"-->
<!--                inactive-value="1">-->
<!--              </el-switch>-->
<!--            </el-form-item>-->
          </el-col>
        </el-row>
        <el-row style="text-align: center">
          <el-col :span="24">
            <el-form-item>
              <el-button type="primary" @click="onSubmit">Search</el-button>
              <el-button @click="clear">Clear</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <!--
          <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="68px">
            <el-form-item label="project_id" prop="projectId">
              <el-input
                v-model="queryParams.projectId"
                placeholder="请输入project_id"
                clearable
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item label="asked_by" prop="askedBy">
              <el-input
                v-model="queryParams.askedBy"
                placeholder="请输入asked_by"
                clearable
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item label="quantity" prop="quantity">
              <el-input
                v-model="queryParams.quantity"
                placeholder="请输入quantity"
                clearable
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item label="sample_purpose" prop="samplePurpose">
              <el-input
                v-model="queryParams.samplePurpose"
                placeholder="请输入sample_purpose"
                clearable
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item label="comments" prop="comments">
              <el-input
                v-model="queryParams.comments"
                placeholder="请输入comments"
                clearable
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item label="appeanance" prop="appeanance">
              <el-input
                v-model="queryParams.appeanance"
                placeholder="请输入appeanance"
                clearable
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item label="comments1" prop="comments1">
              <el-input
                v-model="queryParams.comments1"
                placeholder="请输入comments1"
                clearable
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item label="color" prop="color">
              <el-input
                v-model="queryParams.color"
                placeholder="请输入color"
                clearable
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item label="comments2" prop="comments2">
              <el-input
                v-model="queryParams.comments2"
                placeholder="请输入comments2"
                clearable
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item label="function" prop="function">
              <el-input
                v-model="queryParams.function"
                placeholder="请输入function"
                clearable
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item label="comments3" prop="comments3">
              <el-input
                v-model="queryParams.comments3"
                placeholder="请输入comments3"
                clearable
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item label="material" prop="material">
              <el-input
                v-model="queryParams.material"
                placeholder="请输入material"
                clearable
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item label="comments4" prop="comments4">
              <el-input
                v-model="queryParams.comments4"
                placeholder="请输入comments4"
                clearable
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item label="comments5" prop="comments5">
              <el-input
                v-model="queryParams.comments5"
                placeholder="请输入comments5"
                clearable
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item label="qa_color" prop="qaColor">
              <el-input
                v-model="queryParams.qaColor"
                placeholder="请输入qa_color"
                clearable
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item label="qa_qty" prop="qaQty">
              <el-input
                v-model="queryParams.qaQty"
                placeholder="请输入qa_qty"
                clearable
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item label="reception_date" prop="receptionDate">
              <el-date-picker clearable
                              v-model="queryParams.receptionDate"
                              type="date"
                              value-format="yyyy-MM-dd"
                              placeholder="请选择reception_date">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
              <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
            </el-form-item>
          </el-form>
      -->

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button v-if="this.$route.query.sequenceNo"
          type="primary"
          @click="handleAdd"
        >Add</el-button>
      </el-col>
<!--      <el-col :span="1.5">-->
<!--        <el-button-->
<!--          type="primary"-->
<!--          icon="el-icon-edit"-->
<!--          :disabled="single"-->
<!--          @click="handleUpdate"-->
<!--        >Edit</el-button>-->
<!--      </el-col>-->
<!--      <el-col :span="1.5">-->
<!--        <el-button-->
<!--          type="primary"-->
<!--          icon="el-icon-delete"-->
<!--          :disabled="multiple"-->
<!--          @click="handleDelete"-->
<!--        >Delete</el-button>-->
<!--      </el-col>-->
<!--      <el-col :span="1.5">-->
<!--        <el-button-->
<!--          type="warning"-->
<!--          plain-->
<!--          icon="el-icon-download"-->
<!--          size="mini"-->
<!--          @click="handleExport"-->
<!--        >Export</el-button>-->
<!--      </el-col>-->
<!--      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>-->
    </el-row>

    <el-table :data="requestList">
<!--      <el-table-column type="selection" width="55" align="center" />-->
      <el-table-column label="id" show-overflow-tooltip align="center" prop="id" width="150" />
      <el-table-column label="Reception Date" align="center" prop="receptionDate" width="150">
        <template slot-scope="scope">
          <span>{{scope.row.receptionDate}}</span>
        </template>
      </el-table-column>
      <el-table-column label="Project" align="center" prop="projectId" width="100" />
      <el-table-column label="BP" align="center" prop="bp" width="100" />
      <el-table-column label="Brand" align="center" prop="brand" width="100" />
      <el-table-column label="Description" align="center" prop="description" width="100" />
<!--      <el-table-column label="Asked By" align="center" prop="askedBy" />-->
      <el-table-column label="Sample Purpose" show-overflow-tooltip align="center" prop="samplePurpose" width="150" />
      <el-table-column label="Comments" show-overflow-tooltip align="center" prop="comments" width="150" />
      <el-table-column label="Project file link" show-overflow-tooltip align="center" prop="proDescription" width="150" />
      <el-table-column fixed="right" label="QA Status" align="center" prop="qaPlanStatus" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.qaPlanStatus === '1'">
            <el-tag type="success" effect="dark">Accept</el-tag>
          </span>
          <span v-if="scope.row.qaPlanStatus === '2'">
            <el-tag type="danger" effect="dark">Reject</el-tag>
          </span>
          <span v-if="scope.row.qaPlanStatus === '3'">
            <el-tag type="info" effect="dark">Pending</el-tag>
          </span>
          <span v-if="scope.row.qaPlanStatus === '4'">
            <el-tag type="info" effect="dark">FYI</el-tag>
          </span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="DEV Status" align="center" prop="qaStatus" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.qaStatus === '0'">
            <el-tag type="success" effect="dark">Completed</el-tag>
          </span>
          <span v-if="scope.row.qaStatus === '1'">
            <el-tag type="danger" effect="dark">New Request</el-tag>
          </span>
        </template>
      </el-table-column>
<!--      <el-table-column fixed="right" label="QA Plan Status" align="center" prop="qaPlanStatus" width="180">-->
<!--        <template slot-scope="scope">-->
<!--          <span v-if="scope.row.qaPlanStatus === '0'">-->
<!--            <el-button size="mini" type="warning" @click="goQARequset(scope)">QA Report(Unfinished)</el-button>-->
<!--          </span>-->
<!--          <span v-if="scope.row.qaPlanStatus === '1'">-->
<!--            <el-button size="mini" type="success" @click="goQARequsetDetail(scope)">QA Report</el-button>-->
<!--          </span>-->
<!--        </template>-->
<!--      </el-table-column>-->
      <el-table-column label="Quantity" align="center"  width="150" prop="quantity" />
      <!--      <el-table-column label="appeanance" align="center" prop="appeanance" />-->
<!--      <el-table-column label="comments1" align="center" prop="comments1" />-->
<!--      <el-table-column label="color" align="center" prop="color" />-->
<!--      <el-table-column label="comments2" align="center" prop="comments2" />-->
<!--      <el-table-column label="function" align="center" prop="function" />-->
<!--      <el-table-column label="comments3" align="center" prop="comments3" />-->
<!--      <el-table-column label="material" align="center" prop="material" />-->
<!--      <el-table-column label="comments4" align="center" prop="comments4" />-->
<!--      <el-table-column label="comments5" align="center" prop="comments5" />-->
<!--      <el-table-column label="qa_color" align="center" prop="qaColor" />-->
<!--      <el-table-column label="qa_qty" align="center" prop="qaQty" />-->
      <el-table-column fixed="right" label="Operation" align="center" class-name="small-padding fixed-width" width="250">
        <template slot-scope="scope">
          <el-button
            size="mini" plain
            type="info"
            @click="handleView(scope.row)"
          >Print</el-button>
<!--          <el-button-->
<!--            size="mini"-->
<!--            type="text"-->
<!--            @click="handleDelete(scope.row)"-->
<!--          >Send</el-button>-->
          <el-button
            size="mini" plain
            type="info"
            @click="handleUpdate(scope.row)"
          >Edit</el-button>
<!--          <el-button-->
<!--            size="mini" plain-->
<!--            type="info"-->
<!--            @click="goQARequset(scope)"-->
<!--          >QA Report</el-button>-->
          <el-button
            size="mini" plain
            type="info"
            @click="sendMail2(scope)"
          >Mail</el-button>
<!--          <el-button-->
<!--            disabled-->
<!--            size="mini"-->
<!--            type="text"-->
<!--            @click="handleDelete(scope.row)"-->
<!--          >Delete</el-button>-->
        </template>
      </el-table-column>
    </el-table>
      <br>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="1"
        :page-sizes="[20, 40, 80, 100]"
        :page-size="20"
        layout="total, sizes, prev, pager, next, jumper"
        :total=total>
      </el-pagination>
<!--    <pagination-->
<!--      v-show="total>0"-->
<!--      :total="total"-->
<!--      :page.sync="queryParams.pageNum"-->
<!--      :limit.sync="queryParams.pageSize"-->
<!--      @pagination="getList"-->
<!--    />-->
    </el-card>

    <!-- 添加或修改qc qatest request对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="60%" append-to-body>
      <div style="text-align: right">
        <el-button style="right: 0" size="mini" type="primary" @click="submitForm()">Save</el-button>
      </div>
      <el-form ref="form" :model="form" label-width="180px">
        <h3>Base Info:</h3><br>
        <el-form-item label="DEV Status" prop="qaStatus">
          <el-radio v-model="form.qaStatus" label="0">Completed</el-radio>
          <el-radio v-model="form.qaStatus" label="1">New Request</el-radio>
        </el-form-item>
        <el-form-item label="QA Status" prop="qaPlanStatus">
          <el-radio v-model="form.qaPlanStatus" label="1">Pass</el-radio>
          <el-radio v-model="form.qaPlanStatus" label="2">Reject</el-radio>
          <el-radio v-model="form.qaPlanStatus" label="3">Pending</el-radio>
          <el-radio v-model="form.qaPlanStatus" label="4">FYI</el-radio>
        </el-form-item>
        <el-form-item label="Project Id" prop="projectId">
          <el-input disabled v-model="form.projectId" placeholder="Project Id" />
        </el-form-item>
        <el-form-item label="Business Partner" prop="bp">
          <el-input disabled v-model="form.bp" placeholder="Business Partner" />
        </el-form-item>
        <el-form-item label="Brand" prop="brand">
          <el-input disabled v-model="form.brand" placeholder="Brand" />
        </el-form-item>
        <el-form-item label="Project Description" prop="description">
          <el-input v-model="form.description" placeholder="Description" />
        </el-form-item>
        <el-form-item required label="Reception Date" prop="receptionDate">
          <el-date-picker clearable
                          v-model="form.receptionDate"
                          type="date"
                          value-format="yyyy-MM-dd"
                          placeholder="reception_date">
          </el-date-picker>
        </el-form-item>
        <el-form-item required label="Type Of Product" prop="proType">
          <!--          <el-input v-model="form.askedBy" placeholder="Asked By" />-->
          <el-select v-model="form.proType" multiple placeholder="select" @change="changeMethod">
<!--            <el-option-->
<!--              v-for="item in cgList"-->
<!--              :key="item"-->
<!--              :value="item">-->
<!--            </el-option>            -->
            <el-option
              v-for="(item, index) in cgList"
              :key="`${index}-${item.code}`"
              :label="item.description"
              :value="item.code">
              <span style="float: left">{{ item.code }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.description }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item required label="Supplier" prop="supplier">

<!--          <el-select-->
<!--            v-model="form.supplier"-->
<!--            filterable-->
<!--            placeholder="Supplier"-->
<!--            multiple-->
<!--          >-->
<!--            <el-option-->
<!--              v-for="item in sList"-->
<!--              :key="item"-->
<!--              :value="item">-->
<!--            </el-option>-->
<!--          </el-select>-->

          <el-select v-model="form.supplier" filterable multiple placeholder="select" @change="changeMethod">
            <el-option-group>
              <span style="margin-left: 20px; font-size: 10px;width: 30px;">Supplier</span>
              <span style="margin-left: 100px; font-size: 10px;display:inline-block;width: 150px;">Company Name</span>
              <span style="margin-left: 130px; font-size: 10px;display:inline-block; width: 120px;">Short Description</span>
              <el-option
                v-for="(item, index) in contactCRMList"
                :key="`${index}-${item.supplier}`"
                :label="item.supplier"
                :value="item.supplier">
                <span style="float: left; width: 30px;">{{ item.supplier }}</span>
                <span style="margin-left: 100px; color: #8492a6; font-size: 13px; display:inline-block;width: 150px;">{{ item.companyName }}</span>
                <span style="margin-left: 130px; color: #8492a6; font-size: 13px; display:inline-block; width: 60px;">{{ item.shortDescr }}</span>
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
<!--        <el-form-item required label="Request By" prop="askedBy">-->
<!--          <el-select v-model="form.askedBy" multiple placeholder="select">-->
<!--                        <el-option-->
<!--                          v-for="item in createdList"-->
<!--                          :key="item.userId"-->
<!--                          :label="item.userName"-->
<!--                          :value="item.userId">-->
<!--                          <span style="float: left">{{ item.userId }}</span>-->
<!--                          <span style="float: right; margin-right: 30px; color: #8492a6; font-size: 13px">{{ item.userName }}</span>-->
<!--                        </el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->

        <el-form-item required label="Request By" prop="askedBy">
          <el-select v-model="form.askedBy" placeholder="select" @change="changeMethod">
            <el-option
              v-for="(item, index) in createdList"
              :key="`${index}-${item.userId}`"
              :label="item.userName"
              :value="item.userId">
              <span style="float: left">{{ item.userId }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.userName }}</span>
            </el-option>
          </el-select>
        </el-form-item>

<!--        <el-form-item required label="Project Description" prop="proDescription">-->
<!--          <el-input type="text" maxlength="150" show-word-limit v-model="form.proDescription" placeholder="Example: authentic original 30ml her and him" />-->
<!--        </el-form-item>-->
        <el-form-item required label="Sample Purpose" prop="samplePurpose">
<!--          <el-input type="textarea" maxlength="150" show-word-limit v-model="form.samplePurpose" placeholder="Example: fabic C2 test glue:3M&Japanese" />-->
          <el-select v-model="form.samplePurpose" multiple placeholder="select" @change="changeMethod">
            <el-option
              v-for="(item, index) in statusList2"
              :key="`${index}-${item.code}`"
              :label="item.description"
              :value="item.code">
              <span style="float: left">{{ item.code }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.description }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item required label="Quantity" prop="quantity">
          <el-input type="text" maxlength="10" show-word-limit onkeyup="value=value.replace(/[^\d]/g,'')" v-model="form.quantity" placeholder="Quantity" />
        </el-form-item>
        <el-form-item required label="Comments" prop="comments">
          <el-input type="textarea" maxlength="150" show-word-limit v-model="form.comments" placeholder="Comments" />
        </el-form-item>
        <el-form-item label="Project file link" prop="proDescription">
          <el-input type="textarea" maxlength="150" show-word-limit v-model="form.proDescription" placeholder="Project file link" />
        </el-form-item>
        <el-divider></el-divider>
        <h3>Engineer Analysis:</h3><br>
        <el-form-item label="Appeanance" prop="appeanance">
<!--          <el-input v-model="form.appeanance" placeholder="Appeanance" />-->
          <el-radio v-model="form.appeanance" label="0">OK</el-radio>
          <el-radio v-model="form.appeanance" label="1">NG</el-radio>
          <el-radio v-model="form.appeanance" label="2">N/A</el-radio>
        </el-form-item>
        <el-form-item label="Comments" prop="comments1">
          <el-input type="textarea" maxlength="150" show-word-limit v-model="form.comments1" placeholder="Comments" />
        </el-form-item>
        <br>
        <el-form-item label="Color" prop="color">
<!--          <el-input v-model="form.color" placeholder="Color" />-->
          <el-radio v-model="form.color" label="0">OK</el-radio>
          <el-radio v-model="form.color" label="1">NG</el-radio>
          <el-radio v-model="form.color" label="2">N/A</el-radio>
        </el-form-item>
        <el-form-item label="Comments" prop="comments2">
          <el-input type="textarea" maxlength="150" show-word-limit v-model="form.comments2" placeholder="Comments" />
        </el-form-item>
        <br>
        <el-form-item label="Function" prop="functionv">
<!--          <el-input v-model="form.function" placeholder="Function" />-->
          <el-radio v-model="form.functionv" label="0">OK</el-radio>
          <el-radio v-model="form.functionv" label="1">NG</el-radio>
          <el-radio v-model="form.functionv" label="2">N/A</el-radio>
        </el-form-item>
<!--        <el-form-item label="Comments" prop="comments3">-->
<!--          <el-input type="textarea" maxlength="150" show-word-limit v-model="form.comments3" placeholder="Comments" />-->
<!--        </el-form-item>-->
        <br>
        <el-form-item label="Deco" prop="comments3">
          <el-select v-model="form.comments3" multiple placeholder="select" @change="changeMethod">
            <el-option
              v-for="(item, index) in decoList"
              :key="`${index}-${item.code}`"
              :label="item.description"
              :value="item.code">
              <span style="float: left">{{ item.code }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.description }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <br>
        <el-form-item label="Material" prop="material">
          <el-select v-model="form.material" multiple placeholder="select" @change="changeMethod">
            <el-option
              v-for="(item, index) in materialList"
              :key="`${index}-${item.code}`"
              :label="item.description"
              :value="item.code">
              <span style="float: left">{{ item.code }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.description }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <br>
<!--        <el-form-item label="Material" prop="material">-->
<!--          <el-radio v-model="form.material" label="0">OK</el-radio>-->
<!--          <el-radio v-model="form.material" label="1">NG</el-radio>-->
<!--        </el-form-item>-->
        <el-form-item label="Comments" prop="comments4">
          <el-input type="textarea" maxlength="150" show-word-limit v-model="form.comments4" placeholder="Comments" />
        </el-form-item>
        <el-divider></el-divider>
        <h3>QA Required:</h3><br>
        <el-form-item label="Appearance" prop="qaAppearance">
          <el-checkbox v-model="form.qaAppearance" :true-label="'1'" :false-label="'0'">Appearance</el-checkbox>
        </el-form-item>
        <el-form-item label="Color" prop="qaColor">
<!--          <el-input v-model="form.qaColor" placeholder="Color" />-->
          <el-checkbox v-model="form.qaColor" :true-label="'1'" :false-label="'0'">Color</el-checkbox>
        </el-form-item>
        <el-form-item label="Qty" prop="qaQty">
          <el-input type="text" maxlength="10" show-word-limit onkeyup="value=value.replace(/[^\d]/g,'')" v-model="form.qaQty" placeholder="Qty" />
          <span>pcs</span>
        </el-form-item>
        <el-form-item label="Dimension" prop="qaDimension">
          <el-checkbox v-model="form.qaDimension" :true-label="'1'" :false-label="'0'">Dimension</el-checkbox>
        </el-form-item>
        <el-form-item label="Drawing" prop="qaDrawing">
          <el-input type="text" maxlength="50" show-word-limit v-model="form.qaDrawing" placeholder="Drawing" />
        </el-form-item>
        <el-form-item label="Weight/OFC" prop="qaOfc">
          <el-checkbox v-model="form.qaOfc" :true-label="'1'" :false-label="'0'">Weight/OFC</el-checkbox>
        </el-form-item>
        <el-form-item label="Folding Carton Ink Rub Test" prop="qaFolding">
          <el-checkbox v-model="form.qaFolding" :true-label="'1'" :false-label="'0'">Folding Carton Ink Rub Test</el-checkbox>
        </el-form-item>
        <el-form-item label="Tape Test" prop="qaTape">
          <el-checkbox v-model="form.qaTape" :true-label="'1'" :false-label="'0'">Tape Test</el-checkbox>
        </el-form-item>
        <el-form-item label="Tape test with grid pattern" prop="qaPattern">
          <el-checkbox v-model="form.qaPattern" :true-label="'1'" :false-label="'0'">Tape test with grid pattern</el-checkbox>
        </el-form-item>
        <el-form-item label="Perfume Test 15min" prop="qaPerfume">
          <el-checkbox v-model="form.qaPerfume" :true-label="'1'" :false-label="'0'">Perfume Test 15min</el-checkbox>
        </el-form-item>
        <el-form-item label="Perfume Test - ageing @60C" prop="qaPerfumeAge">
          <el-checkbox v-model="form.qaPerfumeAge" :true-label="'1'" :false-label="'0'">Perfume Test - ageing @60C</el-checkbox>
        </el-form-item>
        <el-form-item label="Perfume Test - Room temperature @3days" prop="qaPerfumeRoom">
          <el-checkbox v-model="form.qaPerfumeRoom" :true-label="'1'" :false-label="'0'">Perfume Test - IPPKG-101-V6 - RT @3days</el-checkbox>
        </el-form-item>
        <el-form-item label="Days" prop="qaPerfumeTime">
          <el-input type="text" maxlength="10" show-word-limit onkeyup="value=value.replace(/[^\d]/g,'')" v-model="form.qaPerfumeTime" placeholder="Days" />
        </el-form-item>
<!--        <el-form-item label="Traction Force" prop="qaTraction">-->
<!--          <el-checkbox v-model="form.qaTraction" :true-label="'1'" :false-label="'0'">Traction Force</el-checkbox>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="Traction Force Between" prop="qaTractionBetween">-->
<!--          <el-input type="textarea" maxlength="150" show-word-limit v-model="form.qaTractionBetween" placeholder="Traction Force Between" />-->
<!--        </el-form-item>-->
        <el-form-item label="Separation Force" prop="qaSeparation">
          <el-checkbox v-model="form.qaSeparation" :true-label="'1'" :false-label="'0'">Separation Force</el-checkbox>
        </el-form-item>
        <el-form-item label="Separation Force Between" prop="qaSeparationBetween">
          <el-input type="textarea" maxlength="150" show-word-limit v-model="form.qaSeparationBetween" placeholder="Separation Force Between" />
        </el-form-item>
        <el-form-item label="Cap Opening Force" prop="qaCapopen">
          <el-checkbox v-model="form.qaCapopen" :true-label="'1'" :false-label="'0'">Cap Opening Force</el-checkbox>
        </el-form-item>
        <el-form-item label="Cap Opening Force Between" prop="qaCapopenBetween">
          <el-input type="textarea" maxlength="150" show-word-limit v-model="form.qaCapopenBetween" placeholder="Cap Opening Force Between" />
        </el-form-item>
        <el-form-item label="Assembly Force" prop="qaAssembly">
          <el-checkbox v-model="form.qaAssembly" :true-label="'1'" :false-label="'0'">Assembly Force &lt; 38kg / 0.3Mpa</el-checkbox>
        </el-form-item>
        <el-form-item label="Assembly Force Between" prop="qaAssemblyBetween">
          <el-input type="textarea" maxlength="150" show-word-limit v-model="form.qaAssemblyBetween" placeholder="Assembly Force Between" />
        </el-form-item>
        <el-form-item label="Fitting Test" prop="qaFitting">
          <el-checkbox v-model="form.qaFitting" :true-label="'1'" :false-label="'0'">Fitting Test</el-checkbox>
        </el-form-item>
        <el-form-item label="Fitting Test Between" prop="qaFittingBetween">
          <el-input type="textarea" maxlength="150" show-word-limit v-model="form.qaFittingBetween" placeholder="Fitting Test Between" />
        </el-form-item>
        <el-form-item label="Leakage Test" prop="qaLeakage">
          <el-checkbox v-model="form.qaLeakage" :true-label="'1'" :false-label="'0'">Leakage Test</el-checkbox>
        </el-form-item>
        <el-form-item label="Folding Carton Glue Resistance Test" prop="qaResistance">
          <el-checkbox v-model="form.qaResistance" :true-label="'1'" :false-label="'0'">Folding Carton Glue Resistance Test</el-checkbox>
        </el-form-item>
<!--        <el-form-item label="Ageing Test" prop="qaAgeing">-->
<!--          <el-checkbox v-model="form.qaAgeing" :true-label="'1'" :false-label="'0'">Ageing Test</el-checkbox>-->
<!--        </el-form-item>-->
        <el-form-item label="Drop Test" prop="qaIndividual">
          <el-checkbox v-model="form.qaIndividual" :true-label="'1'" :false-label="'0'">Individual pcs 1m, 1 time, 3 sides</el-checkbox>
        </el-form-item>
        <el-form-item label="Drop Test" prop="qaCarton">
          <el-checkbox v-model="form.qaCarton" :true-label="'1'" :false-label="'0'">Master carton 1m, 3 times, 3 sides</el-checkbox>
        </el-form-item>
        <el-form-item label="Drop Test" prop="qaDropSop201">
          <el-checkbox v-model="form.qaDropSop201" :true-label="'1'" :false-label="'0'">SOP-IPPKG-201-V1</el-checkbox>
        </el-form-item>
        <el-form-item label="Transportation Test" prop="qaTransportation">
          <el-checkbox v-model="form.qaTransportation" :true-label="'1'" :false-label="'0'">Transportation Test 220~240rpm, 2h</el-checkbox>
        </el-form-item>
        <el-form-item label="Vibration Test" prop="qaVibratioSop201">
          <el-checkbox v-model="form.qaVibratioSop201" :true-label="'1'" :false-label="'0'">SOP-IPPKG-201-V1</el-checkbox>
        </el-form-item>
        <el-form-item label="60C" prop="qaAgeTem">
          <el-checkbox v-model="form.qaAgeTem" :true-label="'1'" :false-label="'0'">60C</el-checkbox>
        </el-form-item>
        <el-form-item label="Days" prop="qaAgeTime">
          <el-input type="text" maxlength="10" show-word-limit onkeyup="value=value.replace(/[^\d]/g,'')" v-model="form.qaAgeTime" placeholder="Days" />
        </el-form-item>
        <el-form-item label="Ageing Test" prop="qaShock">
          <el-checkbox v-model="form.qaShock" :true-label="'1'" :false-label="'0'">Ageing Test 50C/-20C, 2 Cycles</el-checkbox>
        </el-form-item>
        <el-form-item label="comments5" prop="comments5">
          <el-input type="textarea" maxlength="150" show-word-limit v-model="form.comments5" placeholder="请输入comments5" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm()">Save</el-button>
        <el-button @click="cancel">Cancel</el-button>
      </div>
    </el-dialog>
    <div id="printTest">
      <el-dialog title="" :visible.sync="dialogVisible"  width="100%" top="0">
<!--        <el-radio-group v-model="size">-->
<!--          <el-radio label="">默认</el-radio>-->
<!--          <el-radio label="medium">中等</el-radio>-->
<!--          <el-radio label="small">小型</el-radio>-->
<!--          <el-radio label="mini">超小</el-radio>-->
<!--        </el-radio-group>-->
        <el-card>
        <div style="text-align: right">
          <el-button type="primary" size="small" v-print="'#printTest'">Print</el-button>
        </div>
        <h1 style="text-align: center;font-weight: bold;font-size: 30px">QA TEST REQUEST</h1>
          <p style="text-align: center">ID:{{form.id}}</p>
        <el-descriptions class="margin-top" title="Project Info:" :column="2" :size="size" border :contentStyle="CS">
          <el-descriptions-item>
            <template slot="label">
              Reception Date
            </template>
            {{form.receptionDate}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              Request By
            </template>
            {{form.askedBy}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              Vendor
            </template>
            {{form.supplier}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              Brand
            </template>
            {{form.brand}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              Project Number
            </template>
            {{form.projectId}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              Business Partner
            </template>
            {{form.bp}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              Project Description
            </template>
            {{form.description}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              Quantity
            </template>
            {{form.quantity}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              Sample Purpose
            </template>
            {{form.samplePurpose}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              Comments
            </template>
            {{form.comments}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              Type Of Product
            </template>
            {{form.proType}}
          </el-descriptions-item>
          <el-descriptions-item>
<!--            <template slot="label">-->
<!--            </template>-->
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              Project file link
            </template>
            {{form.proDescription}}
          </el-descriptions-item>
        </el-descriptions>
<!--          <el-descriptions :column="1" :size="size" border>-->
<!--            <el-descriptions-item>-->
<!--              <template slot="label">-->
<!--                Sample Purpose-->
<!--              </template>-->
<!--              {{form.samplePurpose}}-->
<!--            </el-descriptions-item>-->
<!--            <el-descriptions-item>-->
<!--              <template slot="label">-->
<!--                Comments-->
<!--              </template>-->
<!--              {{form.comments}}-->
<!--            </el-descriptions-item>-->
<!--          </el-descriptions>-->
          <br>
        <el-descriptions class="margin-top" title="Engineer Analysis:" :column="1" :size="size" border :contentStyle="CS">
<!--          <template slot="extra">-->
<!--            <p>121231</p>-->
<!--          </template>-->
          <el-descriptions-item>
            <template slot="label">
              Appeanance
            </template>
              <el-checkbox :true-label="'0'" disabled v-model="form.appeanance" label="0">OK</el-checkbox>
              <el-checkbox :true-label="'1'" disabled v-model="form.appeanance" label="1">NG</el-checkbox>
              <el-checkbox :true-label="'2'" disabled v-model="form.appeanance" label="2">N/A</el-checkbox>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              Comments
            </template>
            {{form.comments1}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              Color
            </template>
            <el-checkbox :true-label="'0'" disabled v-model="form.color" label="0">OK</el-checkbox>
            <el-checkbox :true-label="'1'" disabled v-model="form.color" label="1">NG</el-checkbox>
            <el-checkbox :true-label="'2'" disabled v-model="form.color" label="2">N/A</el-checkbox>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              Comments
            </template>
            {{form.comments2}}
          </el-descriptions-item>
          <el-descriptions-item>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              Function
            </template>
            <el-checkbox :true-label="'0'" disabled v-model="form.functionv" label="0">OK</el-checkbox>
            <el-checkbox :true-label="'1'" disabled v-model="form.functionv" label="1">NG</el-checkbox>
            <el-checkbox :true-label="'2'" disabled v-model="form.functionv" label="2">N/A</el-checkbox>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              Deco
            </template>
            {{form.comments3}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              Material
            </template>
            {{form.material}}
<!--            <el-checkbox :true-label="'0'" disabled v-model="form.material" label="0">OK</el-checkbox>-->
<!--            <el-checkbox :true-label="'1'" disabled v-model="form.material" label="1">NG</el-checkbox>-->
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              Comments
            </template>
            {{form.comments4}}
          </el-descriptions-item>
        </el-descriptions>
        <br>
        <el-descriptions class="margin-top" title="QA Required:" :column="1" :size="size" border>
          <el-descriptions-item>
            <template slot="label">
              Type
            </template>
            <div style="width: 100%;display: flex">
              <el-checkbox disabled style="flex: 1" v-model="form.qaAppearance" :true-label="'1'" :false-label="'0'">Appearance</el-checkbox>
              <el-checkbox disabled style="flex: 1" v-model="form.qaColor" :true-label="'1'" :false-label="'0'">Color</el-checkbox>
              <span style="flex: 1">Qty
                <input disabled style="border:none;border-bottom:1px solid #000;text-align: center" placeholder="" v-model="form.qaQty">
                pcs</span>
            </div>
            <br>
            <div style="width: 100%;display: flex">
              <el-checkbox disabled style="flex: 1" v-model="form.qaDimension" :true-label="'1'" :false-label="'0'">Dimension</el-checkbox>
              <span style="flex: 2">Drawing
                <input disabled style="width: 75%;border:none;border-bottom:1px solid #000;text-align: center" placeholder="" v-model="form.qaDrawing">
              </span>
            </div>
            <br>
            <div style="width: 100%;display: flex">
              <el-checkbox disabled style="flex: 1" v-model="form.qaOfc" :true-label="'1'" :false-label="'0'">Weight/OFC</el-checkbox>
              <el-checkbox disabled style="flex: 2" v-model="form.qaFolding" :true-label="'1'" :false-label="'0'">Folding Carton Ink Rub Test</el-checkbox>
            </div>
            <br>
            <div style="width: 100%;display: flex">
              <el-checkbox disabled style="flex: 1" v-model="form.qaTape" :true-label="'1'" :false-label="'0'">Tape Test</el-checkbox>
              <el-checkbox disabled style="flex: 2" v-model="form.qaPattern" :true-label="'1'" :false-label="'0'">Tape test with grid pattern</el-checkbox>
            </div>
            <br>
            <div style="width: 100%;display: flex">
              <el-checkbox disabled style="flex: 1"  v-model="form.qaPerfume" :true-label="'1'" :false-label="'0'">Perfume Test 15min</el-checkbox>
              <el-checkbox disabled style="flex: 1"  v-model="form.qaPerfumeAge" :true-label="'1'" :false-label="'0'">Perfume Test - ageing @60C</el-checkbox>
              <span style="flex: 1">Days
                <input disabled style="border:none;border-bottom:1px solid #000;text-align: center" placeholder="" v-model="form.qaPerfumeTime">
              </span>
            </div>
            <br>
            <div style="width: 100%;display: flex">
              <el-checkbox disabled style="flex: 1"  v-model="form.qaPerfumeRoom" :true-label="'1'" :false-label="'0'">Perfume Test - IPPKG-101-V6 - RT @3days</el-checkbox>
            </div>
            <br>
<!--            <div style="width: 100%;display: flex">-->
<!--              <el-checkbox disabled style="flex: 1" v-model="form.qaTraction" :true-label="'1'" :false-label="'0'">Traction Force</el-checkbox>-->
<!--              <span style="flex: 2">Between-->
<!--                <input disabled style="width: 75%;border:none;border-bottom:1px solid #000;text-align: center" placeholder="" v-model="form.qaTractionBetween">-->
<!--              </span>-->
<!--            </div>-->
<!--            <br>-->
            <div style="width: 100%;display: flex">
              <el-checkbox disabled style="flex: 1" v-model="form.qaSeparation" :true-label="'1'" :false-label="'0'">Separation Force</el-checkbox>
              <span style="flex: 2">Between
                <input disabled style="width: 75%;border:none;border-bottom:1px solid #000;text-align: center" placeholder="" v-model="form.qaSeparationBetween">
              </span>
            </div>
            <br>
            <div style="width: 100%;display: flex">
              <el-checkbox disabled style="flex: 1" v-model="form.qaCapopen" :true-label="'1'" :false-label="'0'">Cap Opening Force</el-checkbox>
              <span style="flex: 2">Between
                <input disabled style="width: 75%;border:none;border-bottom:1px solid #000;text-align: center" placeholder="" v-model="form.qaCapopenBetween">
              </span>
            </div>
            <br>
            <div style="width: 100%;display: flex">
              <el-checkbox disabled style="flex: 1" v-model="form.qaAssembly" :true-label="'1'" :false-label="'0'">Assembly Force &lt; 38kg / 0.3Mpa</el-checkbox>
              <span style="flex: 2">Between
                <input disabled style="width: 75%;border:none;border-bottom:1px solid #000;text-align: center" placeholder="" v-model="form.qaAssemblyBetween">
              </span>
            </div>
            <br>
            <div style="width: 100%;display: flex">
              <el-checkbox disabled style="flex: 1" v-model="form.qaFitting" :true-label="'1'" :false-label="'0'">Fitting Test</el-checkbox>
              <span style="flex: 2">Between
                <input disabled style="width: 75%;border:none;border-bottom:1px solid #000;text-align: center" placeholder="" v-model="form.qaFittingBetween">
              </span>
            </div>
            <br>
            <div style="width: 100%;display: flex">
              <el-checkbox disabled style="flex: 1" v-model="form.qaLeakage" :true-label="'1'" :false-label="'0'">Leakage Test</el-checkbox>
              <el-checkbox disabled style="flex: 2" v-model="form.qaResistance" :true-label="'1'" :false-label="'0'">Folding Carton Glue Resistance Test</el-checkbox>
<!--              <div style="flex: 1"></div>-->
            </div>
            <br>
            <div style="width: 100%;display: flex">
              <el-checkbox disabled style="flex: 1" v-model="form.qaIndividual" :true-label="'1'" :false-label="'0'">Drop Test - Individual pcs 1m, 1 time, 3 sides</el-checkbox>
              <el-checkbox disabled style="flex: 2" v-model="form.qaCarton" :true-label="'2'" :false-label="'0'">Drop Test - Master carton 1m, 3 times, 3 sides</el-checkbox>
            </div>
            <br>
            <div style="width: 100%;display: flex">
              <el-checkbox disabled style="flex: 1" v-model="form.qaDropSop201" :true-label="'1'" :false-label="'0'">Drop Test - SOP-IPPKG-201-V1</el-checkbox>
              <el-checkbox disabled style="flex: 2" v-model="form.qaVibratioSop201" :true-label="'1'" :false-label="'0'">Vibration Test - SOP-IPPKG-201-V1</el-checkbox>
            </div>
            <br>
            <div style="width: 100%;display: flex">
              <el-checkbox disabled style="flex: 1" v-model="form.qaTransportation" :true-label="'1'" :false-label="'0'">Transportation Test 220~240rpm, 2h</el-checkbox>
<!--              <el-checkbox disabled style="flex: 2" v-model="form.qaVibratioSop201" :true-label="'1'" :false-label="'0'">SOP-IPPKG-201-V1</el-checkbox>-->
            </div>
            <br>
            <div style="width: 100%;display: flex">
<!--              <el-checkbox disabled style="flex: 1" v-model="form.qaAgeing" :true-label="'1'" :false-label="'0'">Ageing Test</el-checkbox>-->
              <el-checkbox disabled style="flex: 1" v-model="form.qaAgeTem" :true-label="'1'" :false-label="'0'">60C
                <span>
                <input disabled style="border:none;border-bottom:1px solid #000;text-align: center" placeholder="" v-model="form.qaAgeTime">
                Days
              </span>
              </el-checkbox>
              <el-checkbox disabled style="flex: 2" v-model="form.qaShock" :true-label="'1'" :false-label="'0'">Ageing Test 50C/-20C, 2 Cycles</el-checkbox>
            </div>
            <br>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              Comments
            </template>
            {{form.comments5}}
          </el-descriptions-item>
        </el-descriptions>
        </el-card>
        <!--        <br><br>-->
<!--        <el-button type="primary" v-print="'#printTest'">Print</el-button>-->
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QATestRequest',
  data () {
    return {
      materialList: [],
      decoList: [],
      createdList: [],
      contactCRMList: [],
      statusList2: [],
      categoryList2: [],
      page: 1,
      size: '10',
      pickerOptions: {
        shortcuts: [{
          text: 'Last week',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: 'Last month',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: 'Last 3 months',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      dateRange: [],
      options: [{
        value: '1',
        label: 'Pass'
      }, {
        value: '2',
        label: 'Reject'
      }, {
        value: '3',
        label: 'Pending'
      }, {
        value: '4',
        label: 'FYI'
      }],
      options2: [{
        value: '0',
        label: 'Completed'
      }, {
        value: '1',
        label: 'New Request'
      }],
      ccList: [],
      mailStatus: true,
      CS: {
        'text-align': 'left',
        'max-width': '400px',
        'word-break': 'break-all'
      },
      cgList: [],
      sList: [],
      askedBy: '',
      // askedBy: ['David Huang', 'Jack Liu', 'Yuhang Dong', 'Tom Wang', 'Jane Chen', 'Bruce Liu', 'Shuhua Cai', 'Martha Wang', 'Linda Wang'],
      // size: '',
      dialogVisible: false,
      project: {},
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // qc qatest request表格数据
      requestList: [],
      // 弹出层标题
      title: '',
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        qaPlanStatus: '',
        id: null,
        projectId: null,
        askedBy: null,
        quantity: null,
        samplePurpose: null,
        comments: null,
        appeanance: null,
        comments1: null,
        color: null,
        comments2: null,
        function: null,
        comments3: null,
        material: null,
        comments4: null,
        comments5: null,
        qaColor: null,
        qaQty: null,
        receptionDate: null
      },
      // 表单参数
      form: {}
    }
  },
  created () {
    this.project = this.$route.query
    this.queryParams.projectId = this.project.sequenceNo
    // this.getList()
    this.onSubmit()
    this.getSupplierList()
    this.getCgList()
    this.getTaskCategories()
    this.getStatusList()
    this.getSuppliers()
    this.getUserByList()
    this.getDecos()
    this.getMaterials()
  },
  methods: {
    changeMethod () {
      this.$forceUpdate()
    },
    async getDecos () {
      const { data: res4 } = await this.$http.get('/customer/getDecoList')
      this.decoList = await res4.decoList
    },
    async getMaterials () {
      const { data: res5 } = await this.$http.get('/customer/getMaterialList')
      this.materialList = await res5.materialList
    },
    async getUserByList () {
      const { data: res8 } = await this.$http.get('/customer/getUserByList')
      this.createdList = await res8.userByList
      // console.log(this.contactCRMList)
    },
    async getSuppliers () {
      const { data: res2 } = await this.$http.get('/customer/getSupplierList')
      this.contactCRMList = await res2.bpSupplierList
      // console.log(this.contactCRMList)
    },
    async getStatusList () {
      const { data: res6 } = await this.$http.get('/customer/getStatusList')
      this.statusList2 = await res6.statusList
      // console.log(this.statusList2)
    },
    async getTaskCategories () {
      const { data: res3 } = await this.$http.get('/customer/getTaskCategoryList')
      this.categoryList2 = await res3.taskCategoryList
      // const list = []
      // for (let i = 0; i < this.categoryList2.length; i++) {
      //   list.push(this.categoryList2[i].code)
      // }
      this.cgList = this.categoryList2
      // console.log(this.cgList)
      // console.log(this.categoryList2)
    },
    async handleSizeChange (val) {
      const { data: res } = await this.$http.get('/QAProject/getQARequestList?startDate=' + this.dateRange[0] + '&&endDate=' + this.dateRange[1] + '&&page=' + this.page + '&&size=' + val,
        {
          params: {
            Brand: this.queryParams.brand,
            projectId: this.queryParams.projectId,
            id: this.queryParams.id,
            qaStatus: this.queryParams.qaStatus,
            qaPlanStatus: this.queryParams.qaPlanStatus
          }
        }
      )
      this.requestList = res.records
      this.total = res.total
    },
    async handleCurrentChange (val) {
      const { data: res } = await this.$http.get('/QAProject/getQARequestList?startDate=' + this.dateRange[0] + '&&endDate=' + this.dateRange[1] + '&&page=' + val + '&&size=' + this.size,
        {
          params: {
            Brand: this.queryParams.brand,
            projectId: this.queryParams.projectId,
            id: this.queryParams.id,
            qaStatus: this.queryParams.qaStatus,
            qaPlanStatus: this.queryParams.qaPlanStatus
          }
        }
      )
      this.requestList = res.records
      this.total = res.total
    },
    clear () {
      this.dateRange = []
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        qaPlanStatus: '',
        id: null,
        projectId: null,
        askedBy: null,
        quantity: null,
        samplePurpose: null,
        comments: null,
        appeanance: null,
        comments1: null,
        color: null,
        comments2: null,
        function: null,
        comments3: null,
        material: null,
        comments4: null,
        comments5: null,
        qaColor: null,
        qaQty: null,
        receptionDate: null
      }
    },
    async qaStatusChange () {
      // const { data: res } = await this.$http.get('/QAProject/getQARequestList',
      //   {
      //     params: {
      //       projectId: this.project.sequenceNo
      //     }
      //   }
      // )
      // this.requestList = res
    },
    async onSubmit () {
      const { data: res } = await this.$http.get('/QAProject/getQARequestList?startDate=' + this.dateRange[0] + '&&endDate=' + this.dateRange[1] + '&&page=' + this.page + '&&size=' + this.size,
        {
          params: {
            Brand: this.queryParams.brand,
            projectId: this.queryParams.projectId,
            id: this.queryParams.id,
            qaStatus: this.queryParams.qaStatus,
            qaPlanStatus: this.queryParams.qaPlanStatus
          }
        }
      )
      this.requestList = res.records
      this.total = res.total
    },
    // sendMail2 (x) {
    //   console.log(x.row.askedBy)
    // },
    sendMail2 (x) {
      let sendmail = ''
      switch (x.row.askedBy) {
        case 'JLU':
          sendmail = 'Jack@sourcingperfumecosmetic.com'
          break
        case 'YDG':
          sendmail = 'yuhang@sourcingperfumecosmetic.com'
          break
        case 'TWG':
          sendmail = 'Tom@sourcingperfumecosmetic.com'
          break
        case 'RHI':
          sendmail = 'Rhian@sourcingperfumecosmetic.com'
          break
        // case 'JCH':
        //   sendmail = 'Jane@sourcingperfumecosmetic.com'
        //   break
        // case 'JCH':
        //   sendmail = 'Jane@sourcingperfumecosmetic.com'
        //   break
        case 'LWG':
          sendmail = 'linda@sourcingperfumecosmetic.com'
          break
        case 'ALLEN':
          sendmail = 'allen@sourcingperfumecosmetic.com'
          break
      }
      const CCMails = [
        // 'Lucian@sourcingperfumecosmetic.com',
        // 'philippegozlan@j3p.biz',
        'davidh@sourcingperfumecosmetic.com',
        'Tom@sourcingperfumecosmetic.com',
        'bruce@sourcingperfumecosmetic.com',
        'shuhua@sourcingperfumecosmetic.com',
        'martha@sourcingperfumecosmetic.com'
      ]
      CCMails.push(sendmail)
      this.ccList = CCMails
      const confirmText = this.ccList
      const newDatas = []
      const h = this.$createElement
      for (const i in confirmText) {
        newDatas.push(h('p', null, confirmText[i]))
      }
      this.$confirm(
        'Confirm to send the QA Test Request to',
        {
          // confirmButtonText: 'Send',
          title: 'Confirm to send QA Test Request to',
          message: h('div', null, newDatas),
          showCancelButton: true
        }).then(() => {
        this.sendMail(x)
      }).catch(() => {
        console.log('0')
      })
    },
    async sendMail (x) {
      // 开发质控发送邮箱配置
      if (this.mailStatus) {
        this.mailStatus = false
        let sendmail = ''
        switch (x.row.askedBy) {
          // case 'Jack Liu':
          //   sendmail = 'Jack@sourcingperfumecosmetic.com'
          //   break
          // case 'Yuhang Dong':
          //   sendmail = 'yuhang@sourcingperfumecosmetic.com'
          //   break
          // case 'Tom Wang':
          //   sendmail = 'Tom@sourcingperfumecosmetic.com'
          //   break
          // case 'Jean Chen':
          //   sendmail = 'Jane@sourcingperfumecosmetic.com'
          //   break
          // case 'Jane Chen':
          //   sendmail = 'Jane@sourcingperfumecosmetic.com'
          //   break
          // case 'Linda Wang':
          //   sendmail = 'linda@sourcingperfumecosmetic.com'
          //   break
          // case 'Iris Yang':
          //   sendmail = 'Iris@sourcingperfumecosmetic.com'
          //   break
          case 'JLU':
            sendmail = 'Jack@sourcingperfumecosmetic.com'
            break
          case 'YDG':
            sendmail = 'yuhang@sourcingperfumecosmetic.com'
            break
          case 'TWG':
            sendmail = 'Tom@sourcingperfumecosmetic.com'
            break
          case 'RHI':
            sendmail = 'Rhian@sourcingperfumecosmetic.com'
            break
          // case 'JCH':
          //   sendmail = 'Jane@sourcingperfumecosmetic.com'
          //   break
          // case 'JCH':
          //   sendmail = 'Jane@sourcingperfumecosmetic.com'
          //   break
          case 'LWG':
            sendmail = 'linda@sourcingperfumecosmetic.com'
            break
          case 'ALLEN':
            sendmail = 'allen@sourcingperfumecosmetic.com'
            break
        }
        const CCMails = [
          // 'Lucian@sourcingperfumecosmetic.com',
          // 'philippegozlan@j3p.biz',
          'davidh@sourcingperfumecosmetic.com',
          'Tom@sourcingperfumecosmetic.com',
          'bruce@sourcingperfumecosmetic.com',
          'shuhua@sourcingperfumecosmetic.com',
          'martha@sourcingperfumecosmetic.com',
          'Jacky@sourcingperfumecosmetic.com'
        ]
        CCMails.push(sendmail)
        this.ccList = CCMails
        const sendmail2 = '123'
        const { data: res } = await this.$http.get('/qaReport/mailRequest?sendMails=' + sendmail2 + '&CCMails=' + CCMails, { params: x.row })
        // console.log(res)
        if (res.result === 'Send success') {
          this.$message({
            message: 'Send Success',
            type: 'success'
          })
          this.mailStatus = false
        }
      } else {
        this.$message({
          message: 'Send repeatedly',
          type: 'error'
        })
      }
    },
    async getSupplierList () {
      const { data: res } = await this.$http.get('/supplier/getSupplierList')
      const ssList = []
      for (let i = 0; i < res.length; i++) {
        ssList.push(res[i].supplierName)
      }
      this.sList = ssList
    },
    goQARequsetDetail (index) {
      // this.$router.push(`/qaReportDetail?projectId=${index.row.projectId}`)
      // this.$router.push(`/qaReportDetail?id=${index.row.id}`)
      this.$router.push(`/qaReport?id=${index.row.id}`)
    },
    goQARequset (index) {
      // this.$router.push(`/qaReport?projectId=${index.row.projectId}`)
      this.$router.push(`/qaReport?id=${index.row.id}`)
    },
    /** 查询列表 */
    async getList () {
      this.loading = true
      const { data: res } = await this.$http.get('/QAProject/getQARequestList',
        {
          params: {
            projectId: this.project.sequenceNo
          }
        }
      )
      this.requestList = res.records
      this.total = res.total
      // 执行查询
      // getQatestRequestPage (this.queryParams).then(response => {
      //   this.list = response.data.list
      //   this.total = response.data.total
      //   this.loading = false
      // })
    },
    /** 取消按钮 */
    cancel () {
      this.open = false
      this.reset()
    },
    /** 表单重置 */
    reset () {
      this.form = {
        // id: undefined,
        // projectId: undefined,
        // askedBy: undefined,
        // quantity: undefined,
        // samplePurpose: undefined,
        // comments: undefined,
        // appeanance: undefined,
        // comments1: undefined,
        // color: undefined,
        // comments2: undefined,
        // function: undefined,
        // comments3: undefined,
        // material: undefined,
        // comments4: undefined,
        // comments5: undefined,
        // qaColor: undefined,
        // qaQty: undefined,
        // receptionDate: undefined,
        // createBy: undefined,
        // updateBy: undefined
      }
      // this.resetForm('form')
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParams.pageNo = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      // this.resetForm('queryForm')
      this.handleQuery()
    },
    handleView (row) {
      this.dialogVisible = true
      row.proType = row.proType.toString()
      row.supplier = row.supplier.toString()
      row.samplePurpose = row.samplePurpose.toString()
      row.askedBy = row.askedBy.toString()
      row.material = row.material.toString()
      row.comments3 = row.comments3.toString()
      this.form = row
      console.log(this.form)
    },
    /** 新增按钮操作 */
    handleAdd () {
      this.title = 'Add QA Request'
      // this.reset()
      this.form = {}
      this.open = true
      this.form.projectId = this.project.sequenceNo
      this.form.bp = this.project.bp
      this.form.brand = this.project.brand
      this.form.description = this.project.description
      this.form.receptionDate = new Date()
      this.form.askedBy = this.project.projectLeader
      this.form.samplePurpose = [this.project.status]
      this.form.material = [this.project.material]
      this.form.supplier = this.changeU(this.project.contact.toString())
      this.form.proType = [this.project.category]
      console.log(this.project.category)
      console.log(this.form.proType)
      // console.log(this.project.status)
      // console.log(this.project.contact)
      // console.log(this.form.samplePurpose)
      // console.log(this.form.supplier)
    },
    changeU (s) {
      const s1 = s.substr(1)
      const s2 = s1.substring(0, s1.length - 1)
      return s2.trim().split(',')
    },
    /** 修改按钮操作 */
    handleUpdate (row) {
      this.title = 'Edit QA Request'
      // this.reset()
      this.open = true
      row.proType = row.proType.toString().split(',')
      row.supplier = row.supplier.toString().split(',')
      row.samplePurpose = row.samplePurpose.toString().split(',')
      row.material = row.material.toString().split(',')
      row.comments3 = row.comments3.toString().split(',')
      this.form = row
      // const id = row.id
      // getQatestRequest(id).then(response => {
      //   this.form = response.data;
      //   this.open = true;
      //   this.title = "修改qc qatest request";
      // });
    },
    /** 提交按钮 */
    async submitForm () {
      if (!this.form.projectId) {
        this.$message({
          message: 'Please enter or select projectId',
          type: 'warning'
        })
        return
      }
      if (!this.form.proType) {
        this.$message({
          message: 'Please enter or select proType',
          type: 'warning'
        })
        return
      }
      if (!this.form.bp) {
        this.$message({
          message: 'Please enter or select bp',
          type: 'warning'
        })
        return
      }
      if (!this.form.brand) {
        this.$message({
          message: 'Please enter or select brand',
          type: 'warning'
        })
        return
      }
      if (!this.form.description) {
        this.$message({
          message: 'Please enter or select description',
          type: 'warning'
        })
        return
      }
      if (!this.form.receptionDate) {
        this.$message({
          message: 'Please enter or select receptionDate',
          type: 'warning'
        })
        return
      }
      // if (!this.form.proDescription) {
      //   this.$message({
      //     message: 'Please enter or select proDescription',
      //     type: 'warning'
      //   })
      //   return
      // }
      if (!this.form.supplier) {
        this.$message({
          message: 'Please enter or select supplier',
          type: 'warning'
        })
        return
      }
      if (!this.form.askedBy) {
        this.$message({
          message: 'Please enter or select Request By',
          type: 'warning'
        })
        return
      }
      if (!this.form.quantity) {
        this.$message({
          message: 'Please enter or select quantity',
          type: 'warning'
        })
        return
      }
      if (!this.form.samplePurpose) {
        this.$message({
          message: 'Please enter or select samplePurpose',
          type: 'warning'
        })
        return
      }
      if (!this.form.comments) {
        this.$message({
          message: 'Please enter or select comments',
          type: 'warning'
        })
        return
      }
      this.form.proType = this.form.proType.toString()
      this.form.supplier = this.form.supplier.toString()
      this.form.samplePurpose = this.form.samplePurpose.toString()
      this.form.material = this.form.material.toString()
      this.form.comments3 = this.form.comments3.toString()
      // console.log(this.form)
      await this.$http.post('/QAProject/add', this.form)
        .then((res) => {
          if (res.data.success) {
            // 生成时创建asana
            // if (this.form.id) {
            //   // const sendmail2 = 'x+1205507181922118@mail.asana.com'
            //   const CCMails2 = ['93977131@qq.com']
            //   const { data: res } = this.$http.get('/qaReport/mailRequestCreate?sendMails=' + '&CCMails=' + CCMails2, { params: this.form })
            //   console.log(res)
            // }
            this.$message({
              message: 'Added or updated successfully',
              type: 'success'
            })
            this.open = false
            this.getList()
          }
        })
      // 修改的提交
      // if (this.form.id != null) {
      // updateQatestRequest(this.form).then(response => {
      //   this.$modal.msgSuccess("修改成功");
      //   this.open = false;
      //   this.getList();
      // });
      // return
      // }
      // 添加的提交
      // createQatestRequest(this.form).then(response => {
      //   this.$modal.msgSuccess("新增成功");
      //   this.open = false;
      //   this.getList();
      // });
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      // const id = row.id
      // this.$modal.confirm('是否确认删除qc qatest request编号为"' + id + '"的数据项?').then(function() {
      //   return deleteQatestRequest(id);
      // }).then(() => {
      //   this.getList();
      //   this.$modal.msgSuccess("删除成功");
      // }).catch(() => {});
    },
    /** 导出按钮操作 */
    handleExport () {
      // 处理查询参数
      // let params = {...this.queryParams};
      // params.pageNo = undefined;
      // params.pageSize = undefined;
      // this.$modal.confirm('是否确认导出所有qc qatest request数据项?').then(() => {
      //   this.exportLoading = true;
      //   return exportQatestRequestExcel(params);
      // }).then(response => {
      //   this.$download.excel(response, 'qc qatest request.xls');
      //   this.exportLoading = false;
      // }).catch(() => {});
    },
    async getCgList () {
      const { data: res } = await this.$http.get('/qualityCategories/getQualityCategoriesList', { params: { page: 1, size: 100, type: 'qa', level: 1 } })
      const list = []
      for (let i = 0; i < res.records.length; i++) {
        list.push(res.records[i].name)
      }
      // this.cgList = list
    }
  }
}
</script>

<style scoped>
  .my-class {
    max-width: 100px;
    word-break: break-all;
    word-wrap: break-word
  }
  /deep/  .is-disabled .is-checked .el-checkbox__inner {
    /*background-color: black;*/
    border-color: black;
    color: black;
  }
  /deep/  .is-disabled .is-checked .el-checkbox__inner:after {
    /*background-color: black;*/
    border-color: black;
    color: black;
  }
  /deep/ .element.style{
    margin-top: 0;
  }
  /*/deep/ .el-checkbox__input.is-checked:before {*/
  /*  background-color: black;*/
  /*  border-color: black;*/
  /*  color: black;*/
  /*}*/
  /*/deep/  .is-disabled .el-checkbox__inner {*/
  /*  border: 1px solid #DCDFE6;*/
  /*}*/
  /*/deep/  .is-disabled .el-checkbox__label {*/
  /*!*color: #606266;*!*/
  /*  color: black;*/
  /*}*/
</style>
